/**
 * CRUD for handling the `steps` state object
 */
import {
  mapBranchedSteps,
  arrayFromGraph,
  formatRequestBodyGraph,
  createDelayNode
} from 'components/scenarios/utils/graph/legacy-graph'
import {
  isContinuousStatusCheckNode,
  isDelayNode
} from 'components/scenarios/utils/graph/nodes/typeguards'

/** Sort, reorder, and format steps
 *
 * @param {Array | Object} steps
 * @returns {Array}
 */
export function reformatSteps(steps) {
  try {
    return mapBranchedSteps(arrayFromGraph(formatRequestBodyGraph(steps)))
  } catch {
    return reformatSteps(mapBranchedSteps(arrayFromGraph(steps)))
  }
}

/** Update steps array with edited step and any delay node updates necessary
 *
 * @param {Array} steps
 * @param {int} index
 * @param {Object} editedStep
 * @returns {Array}
 */
export function editStep(steps, index, editedStep) {
  const newSteps = [...steps]
  newSteps[index] = editedStep

  // Add delay node if converting from continuous to synchronous status check
  if (
    !isContinuousStatusCheckNode(editedStep) &&
    !isDelayNode(newSteps[index + 1])
  ) {
    newSteps.splice(index + 1, 0, createDelayNode())
  } else if (
    isContinuousStatusCheckNode(editedStep) &&
    isDelayNode(newSteps[index + 1])
  ) {
    newSteps.splice(index + 1, 1)
  }

  return reformatSteps(newSteps)
}
